exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#signatureBox[data-v-b3c45036] {\n    background-color: lightgray;\n    border: 1px dotted gray;\n}\nh4[data-v-b3c45036] {\n    color: white;\n}\n", ""]);

// exports
